import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './over-marjan.css'

const OverMarjan = (props) => {
  return (
    <div className="over-marjan-container1">
      <Helmet>
        <title>Over Marjan - marjangerrits.nl</title>
        <meta
          name="description"
          content="Marjan Gerrits heeft een dubbelroman geschreven over de Tweede Wereldoorlog"
        />
        <meta
          property="og:title"
          content="Tweede Wereldoorlog - marjangerrits.nl"
        />
        <meta
          property="og:description"
          content="Marjan Gerrits heeft een dubbelroman geschreven over de Tweede Wereldoorlog"
        />
      </Helmet>
      <div className="over-marjan-top">
        <NavbarInteractive
          logo="Marjan Gerrits"
          rootClassName="navbar-interactiveroot-class-name24"
        ></NavbarInteractive>
        <div className="over-marjan-container2">
          <h1>Over mij</h1>
          <span>Schrijversacademie en daarna</span>
        </div>
      </div>
      <div className="over-marjan-main">
        <div className="over-marjan-marjan">
          <img
            alt="image"
            src="/profiel%20insta-700w.jpg"
            className="over-marjan-image1"
          />
          <div className="over-marjan-container3">
            <span className="over-marjan-text12">
              <span className="Content">
                Marjan Gerrits (1963) geboren in Zeist, heeft zich jarenlang in
                het oorlogsverleden van zowel haar Nederlandse vader als haar
                Duitse schoonvader verdiept. Dit onderzoek vormde de basis voor
                haar debuut, de dubbelroman &quot;
              </span>
              <Link to="/" className="over-marjan-navlink Dikgedrukt_tekst">
                Als je niets bent
              </Link>
              <span className="Content">
                &quot;, waarin ze twee verschillende perspectieven op de Tweede
                Wereldoorlog belicht.
              </span>
            </span>
          </div>
        </div>
        <div className="over-marjan-verdere-toelichting">
          <h3 className="Dikgedrukt_tekst over-marjan-text15">
            Schrijversacademie en daarna
          </h3>
          <span className="over-marjan-text16 Content">
            <span>
              Marjan volgde de basismodule aan de Schrijversacademie en daarna
              de specialisatie Familieverhalen en Biografieën.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <br></br>
            <span>
              Ze toverde een monumentaal schuurtje om in een inspirerend
              schrijfhuisje. Hier werkt zij aan haar roman en aan andere vormen
              van woordkunst.
            </span>
            <br></br>
            <br></br>
            <span>
              Het schrijven van een boek gebaseerd op de gebeurtenissen van haar
              vader en schoonvader in de Tweede Wereldoorlog heeft haar leven
              behoorlijk veranderd. Geen kantoorwerk meer, maar
              archiefonderzoek, plekken bezoeken die in het boek voorkomen,
              deskundigen interviewen, Sütterlin leren om de brieven van haar
              schoonvader te kunnen lezen.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
          </span>
          <img
            alt="image"
            src="/schrijfhuisje-700w.jpg"
            className="over-marjan-image2"
          />
          <span className="over-marjan-text27">
            <span>
              Het schuurtje uit 1910, omgetoverd tot inspirerend schrijfhuisje.
            </span>
            <br></br>
          </span>
          <h4 className="Dikgedrukt_tekst over-marjan-text30">
            {' '}
            Spitten, graven om net dat kleine beetje extra informatie boven
            tafel te krijgen
          </h4>
          <span className="over-marjan-text31 Content">
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span>
              {' '}
              En dan de gevonden informatie duidelijk en op een boeiende manier
              opschrijven. De vreugde als ze weer een stukje van de puzzel
              gevonden had, het plezier als het perfecte woord precies om zijn
              plek viel, de blijdschap om nieuwe informatie met haar partner te
              delen over haar vader.
            </span>
            <br></br>
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <span>
              Er waren ook tegenslagen. Soms vond ze de juiste informatie niet,
              ondanks uren onderzoek. Of de tekst liep niet lekker en lukte het
              haar niet de juiste toon te vinden. Ook worstelde ze als debutant
              met onzekerheid: kon ze dit wel? Na de eerste versie van het
              manuscript volgde de redactie. Het hele verhaal werd overhoop
              gegooid en herschrijven was noodzakelijk.
            </span>
          </span>
          <h4 className="Dikgedrukt_tekst over-marjan-text38">
            Als het tegenzat raapte ze zichzelf bij elkaar en dacht aan haar
            doel
          </h4>
          <span className="over-marjan-text39 Content">
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span>
              Er zijn veel oorlogsboeken geschreven, maar hoeveel gaan over de
              gewone jongemannen die in die tijd opgroeiden? De jongemannen die
              probeerden zo goed mogelijk door de oorlog te komen, geen
              bijzondere helden. En toch worden ze in de oorlog meegesleurd. 
            </span>
            <span>
              En hoeveel boeken beschrijven zowel het leven van een Nederlander
              als een Duitser in oorlogstijd? Naar haar mening veel te
              weinig. Door beide perspectieven te belichten, onthult ze de
              complexe realiteit van een tijd waarin grenzen tussen goed en
              kwaad vervaagden en de menselijke veerkracht op de proef werd
              gesteld. Een waardevolle aanvulling op de bestaande literatuur.
            </span>
          </span>
          <h4 className="Dikgedrukt_tekst over-marjan-text43"> Woordkunst </h4>
          <span className="over-marjan-text44 Content">
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span>
              Als tegenwicht voor de zwaarte van het historische onderzoek en
              schrijven over de oorlog, zoekt ze in taal ook lichtheid. Ze maakt
              graag ‘woordkunst’, meestal in de vorm van speelse gedichten en
              haiku’s. Spelen met taal geeft haar hoofd vrijheid. Deze teksten
              zijn niet publiek.
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name25"></Footer>
    </div>
  )
}

export default OverMarjan
